import { render, staticRenderFns } from "./detail-dialog.vue?vue&type=template&id=fe79a3c4&scoped=true"
import script from "./detail-dialog.vue?vue&type=script&lang=js"
export * from "./detail-dialog.vue?vue&type=script&lang=js"
import style0 from "./detail-dialog.vue?vue&type=style&index=0&id=fe79a3c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe79a3c4",
  null
  
)

export default component.exports